// extracted by mini-css-extract-plugin
export default {"monitoring__container":"styles_monitoring__container__NU4At","monitoring__table--wrapper":"styles_monitoring__table--wrapper__5FHKV"};